<template>
  <!-- Add Contact -->
  <div class="modal custom-modal fade custom-modal-two modal-padding" id="update_location" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header header-border justify-content-between p-0">
          <h5 class="modal-title">update Location</h5>
          <button type="button" ref="Close" class="btn-close position-static" data-bs-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body p-0">
          <div class="add-info-fieldset">
            <div class="contact-input-set">
              <div class="row">

                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label">Location <span class="text-danger"> *</span></label>
                    <input class="form-control" type="text" v-model="locationName" />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-block mb-3">
                    <label class="col-form-label">GeoLocation Radius(in meters) <span class="text-danger">
                        *</span></label>
                    <input class="form-control" type="text" v-model="locationRadius" />
                  </div>
                </div>
                <div class="col-md-12">
                  <!-- Container for the map -->
                  <div id="mapEl"></div>
                  <!-- <p>Lat: {{ lat }}</p>
                      <p>Lng: {{ lng }}</p> -->
                </div>
                <div class="col-lg-12 text-end form-wizard-button">
                  <button class="btn btn-primary wizard-next-btn" type="button" data-bs-dismiss="modal"
                    @click="updateLocation">
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Contact -->

</template>

<style scoped>
#mapEl {
  width: 100%;
  height: 50vh;
}
</style>

<script>
import axios from "axios";
// import { ref } from 'vue';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import markerIcon from '@/assets/img/icons/marker.png';
import "leaflet-geosearch/dist/geosearch.css";
import { GeoSearchControl, OpenStreetMapProvider } from "leaflet-geosearch";
import { VUE_APP_API_BASE_URL } from "../../config";
// import draggable from "vuedraggable";

// import 'leaflet-control-geocoder/dist/Control.Geocoder.js';  // For search functionality
// import "leaflet-control-geocoder/dist/Control.Geocoder.css";

export default {
  props: {
    latitude: { type: Number, default: 0.14405508452768728 },
    longitude: { type: Number, default: 51.4893335 },
    locationData: { type: Object, default: () => ({}) }
  },
  data() {
    const myIcon = L.icon({
      iconUrl: markerIcon,
      iconSize: [32, 32]
    });
    return {
      lat: this.latitude,
      lng: this.longitude,
      map: null,
      myIcon,
      locationName: '',
      locationRadius: null,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/London',
      marker: null,
      locationId: ''
      // searchQuery,
      // searchAddress,
    };
  },

  mounted() {
    // if (this.map) return; // avoid double init
    
    // Set up the map
    this.map = L.map('mapEl').setView([this.lat, this.lng], 3);

    // Add OpenStreetMap tile layer
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      minZoom: 1, maxZoom: 18,
      zoomAnimation: false
    }).addTo(this.map);

    // Set up draggable marker
    this.marker = L.marker([this.lat, this.lng], { draggable: true, icon: this.myIcon }).addTo(this.map);

    this.map.on('click', (e) => {
      setTimeout(() => {
        this.map.invalidateSize();
      }, 1);

      this.lat = e.latlng.lat;
      this.lng = e.latlng.lng;
      // this.marker.setLatLng([this.lat, this.lng], { draggable: true, icon: this.myIcon });  // Update marker position
      this.map.setView([this.lat, this.lng], 3);
    });

    // Update latitude and longitude when marker is dragged
    this.marker.on('dragend', () => {
      // setTimeout(() => {
      //   this.map.invalidateSize();
      // }, 1);
      let position = this.marker.getLatLng();
      this.lat = position.lat;
      this.lng = position.lng;
    });

    // Create a geocoding search box using the OpenStreetMap provider
    const provider = new OpenStreetMapProvider();

    // Add the search control to the map
    let searchControl = GeoSearchControl({
      provider: provider,
      showMarker: false,
      showPopup: false,
    });
    this.map.addControl(searchControl);

    // Optional: Add a marker when the search returns a result
    this.map.on("geosearch/showlocation", (e) => {
      this.lat = e.location.x;
      this.lng = e.location.y;
      setTimeout(() => {
        this.map.invalidateSize();
      }, 1);
      this.marker.setLatLng([this.lat, this.lng], { draggable: true, icon: this.myIcon });  // Update marker position
      this.map.setView([this.lat, this.lng], 3);
    });
  },

  beforeUnmount() {
  if (this.map) {
    this.map.off(); // remove listeners
    this.map.remove(); // destroy
    this.map = null;
    this.marker = null;
  }
},



  methods: {
    updateValues(data) {
      // if (this.map) {
      //   this.map.remove();
      // }
      // if (this.map != undefined) { 
      //   this.map = null;
      //   this.map.off();
      //   this.map.remove(); 
      // } 
      console.log('data', data);
      this.locationId = data.id;
      this.locationName = data.name || '';
      this.locationRadius = data.radius || 100;
      this.timezone = data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone || 'Europe/London';
      this.lat = data.latitude ?? this.latitude;
      this.lng = data.longitude ?? this.longitude;
      if (!this.map || !this.marker) return

      this.marker.setLatLng([this.lat, this.lng])

      const currentZoom = this.map.getZoom()



      this.map.setView([this.lat, this.lng], currentZoom)


      // If container size/layout changed (e.g., shown in a modal/tab), reflow tiles
      this.$nextTick(() => this.map.invalidateSize())

    },

    async updateLocation() {
      // this.loader = true;

      await axios.post(`${VUE_APP_API_BASE_URL}/location/${this.locationId}/update`, {
        name: this.locationName,
        latitude: this.lat,
        longitude: this.lng,
        radius: this.locationRadius,
        timezone: this.timezone
      })
        .then((response) => {
          if (response.data.status === true) {
            this.$toast.success(response.data.message);
            this.$emit("locationModal");
            // this.loader = false;
          } else {
            this.$toast.error(response.data.message || response.data.errors);
          }
        }).catch(function (error) {
          console.log(error);
        });
    }
  }
};
</script>
